<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="jumpToPage('schoolModuleRolePermissionAdd', {schoolId})">新增应用角色</el-button>
            <el-button size="medium" type="danger" @click="batchDeleteHandler">删除</el-button>
            <el-input size="medium" class="search-input search-input--right" placeholder="模块名称模糊或者权限路径URL全匹配或者角色名称模糊"
                      v-model="moduleName" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>
        <div >
            <el-table
                :height="windowHeight - 205"
                :data="dataList" border
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="模块常量"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.moduleCode }}
                    </template>

                </el-table-column>
                <el-table-column
                    label="模块名称"
                    prop="moduleName"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="角色常量"
                    align="center"
                    prop="constantId"
                >
                </el-table-column>
                <el-table-column
                    label="角色名称"
                    align="center"
                    prop="roleName"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="jumpToPage('schoolModuleRolePermissionEdit', {schoolId, constantId: scope.row.constantId, roleId: scope.row.roleId, moduleId: scope.row.moduleId})">设置权限</el-button>
                        <el-button type="text" @click="deleteHandler([scope.row])">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        deleteSchoolModuleRole,
        queryModuleRolePermissionList
    } from '@/api/schoolManage';
    export default {
        name: 'schoolModuleRolePermissionList',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                dataList: [],
                multipleSelection:[],
                moduleName: ''
            }
        },
        created() {
            this.queryModuleRolePermissionListFunc()

        },
        activated() {
            this.schoolId = this.$route.query.schoolId;
            this.queryModuleRolePermissionListFunc()
        },
        components: {BackTool},
        mixins: [windowResize, baseMixin],
        methods: {
            getList() {
                this.pagination.pageNo = 1;
                this.queryModuleRolePermissionListFunc();
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            sizeChangeHandler() {
                this.queryModuleRolePermissionListFunc();
            },
            currentChangeHandler() {
                this.queryModuleRolePermissionListFunc();
            },
            batchDeleteHandler() {
                if(this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的角色');
                } else {
                    this.deleteHandler(this.multipleSelection);
                }
            },
            deleteHandler(items) {
                this.$confirm('确认要删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    deleteSchoolModuleRole(items.map(({roleId, moduleId}) => ({
                        roleId, moduleId, schoolId: this.schoolId
                    })))
                        .then(() => {
                            this.queryModuleRolePermissionListFunc();
                        })
                });
            },
            queryModuleRolePermissionListFunc() {
                queryModuleRolePermissionList({
                    schoolId: this.schoolId,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    moduleName: this.moduleName
                })
                    .then(data => {
                        this.dataList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
   
     #moduleAppList{
      padding: 12px;
        .top {
    padding-bottom: 10px;
     a {
            color: #409EFF;
        }
  }}
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList.vue